<template>
  <v-card class="check_item">
    <v-row>
      <v-col cols="2" class="no-padding-col">
        <v-row
          justify="center"
          v-if="userAuthority === 'MANAGER' && isUnderEditing"
          class="middle-icon"
        >
          <CheckListItemDeleteButton @deleteClickAction="deleteItem" />
        </v-row>
        <v-row justify="center" v-if="userAuthority === 'MAINTAINER'" class="middle-icon">
          <CheckListItemCheckBox
            @checkItemAction="checkItemAction"
            :is-checked.sync="inputIsChecked"
          />
        </v-row>
      </v-col>
      <v-col cols="10" class="no-padding-col">
        <v-row>
          <v-col cols="10" xs="10" sm="10" md="8" lg="8" class="no-padding-col">
            <CheckListItemDescription
              :user-authority="userAuthority"
              :is-under-editing="isUnderEditing"
              :text.sync="inputDescription"
            />
          </v-col>
          <v-col cols="6" xs="6" sm="6" md="4" lg="4" class="no-padding-col">
            <v-row class="no-margin-row">
              <v-col cols="5" class="narrow-padding-col">
                <CheckListItemCategoryTab
                  :tab-text.sync="inputCategory"
                  :items="categoryList"
                  :user-authority="userAuthority"
                  :is-under-editing="isUnderEditing"
                  kind="category"
                />
              </v-col>
              <v-col cols="3" class="narrow-padding-col">
                <CheckListItemCategoryTab
                  :tab-text.sync="inputPoint"
                  :items="scoring"
                  :user-authority="userAuthority"
                  :is-under-editing="isUnderEditing"
                  kind="point"
                />
              </v-col>
              <v-col cols="3" class="narrow-padding-col">
                <CheckListItemOpenButton
                  :is-open-detail="isOpenDetail"
                  @openDetailClickAction="openDetailClickAction"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="isOpenDetail">
          <v-col
            cols="12"
            class="no-padding-col"
            v-if="userAuthority === 'MANAGER' && isUnderEditing"
          >
            <CheckListItemEditableDetailText :text.sync="inputReason" class="item_detail_text" />
          </v-col>
          <v-col cols="12" class="no-padding-col" v-else>
            <CheckListItemDetailText :text.sync="inputReason" class="item_detail_text" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import CheckListItemCheckBox from "../Atoms/CheckListItemCheckBox";
import CheckListItemDeleteButton from "../Atoms/CheckListItemDeleteButton";
import CheckListItemDescription from "../Atoms/CheckListItemDescription";
import CheckListItemCategoryTab from "../Atoms/CheckListItemCategoryTab";
import CheckListItemOpenButton from "../Atoms/CheckListItemOpenButton";
import CheckListItemDetailText from "../Atoms/CheckListItemDetailText";
import CheckListItemEditableDetailText from "../Atoms/CheckListItemEditableDetailText";

export default {
  name: "CheckListItem",
  data: () => ({
    isOpenDetail: false,
    categoryList: ["GLOBAL_WARMING", "WATER_POLLUTION"],
    scoring: [5, 3, 1, -1, -3, -5]
  }),
  created() {},
  methods: {
    deleteItem() {
      this.$emit("deleteItem", this.index);
    },
    checkItemAction() {
      this.$emit("checkItem", this.index);
    },
    openDetailClickAction() {
      this.isOpenDetail = !this.isOpenDetail;
    }
  },
  computed: {
    inputDescription: {
      get() {
        return this.description;
      },
      set(value) {
        this.$emit("update:description", value);
      }
    },
    inputCategory: {
      get() {
        return this.category;
      },
      set(value) {
        this.$emit("update:category", value);
      }
    },
    inputPoint: {
      get() {
        return this.point;
      },
      set(value) {
        this.$emit("update:point", value);
      }
    },
    inputReason: {
      get() {
        return this.reason;
      },
      set(value) {
        this.$emit("update:reason", value);
      }
    },
    inputIsChecked: {
      get() {
        return this.isChecked;
      },
      set(value) {
        this.$emit("update:isChecked", value);
      }
    },
  },
  components: {
    CheckListItemCheckBox,
    CheckListItemDeleteButton,
    CheckListItemDescription,
    CheckListItemCategoryTab,
    CheckListItemOpenButton,
    CheckListItemDetailText,
    CheckListItemEditableDetailText
  },
  props: [
    "userAuthority",
    "description",
    "category",
    "point",
    "reason",
    "isUnderEditing",
    "index",
    "isChecked"
  ]
};
</script>

<style scoped>
p {
  margin: 0;
}
.middle-icon {
  margin: 8px 0;
}
.narrow-padding-col {
  padding: 8px 5px;
}
.no-padding-col {
  padding: 0;
}
.no-margin-row {
  margin: 0;
}
.check_item {
  background: #ffffffe6 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 9px #00000029;
  border-radius: 30px;
  padding: 8px 15px;
  margin: 10px 0;
}
.no-padding-col {
  padding: 0;
}
.item_detail_text {
  margin-top: 5px;
}
</style>
